import generateActions from 'utils/actions';

export const POST_COMMENT = generateActions('comments/POST_COMMENT');
export const LOAD_COMMENTS = generateActions('comments/LOAD_COMMENTS');
export const DELETE_COMMENT = generateActions('comments/DELETE_COMMENT');
export const LOAD_THREAD = generateActions('comments/LOAD_THREAD');
export const LOAD_THREADS = generateActions('comments/LOAD_THREADS');

/**
 * Adding a comment to blog
 * @param {Comment} comment 
 */
export function postComment(model, model_id, comment) {
  return {
    types: POST_COMMENT,
    promise: {
      url: `/comments`,
      method: 'POST',
      data: {
        model,
        model_id,
        parent_id: comment.parent_id ? comment.parent_id : undefined,
        title: comment.title,
        body: comment.body,
      },
    },
  };
}

/**
 * Load all comments from the given model
 * @param {String} model 
 * @param {Number} model_id
 */
export function loadComments(model, id) {
  return {
    types: LOAD_COMMENTS,
    promise: {
      url: `/comments/published`,
      data: {
        model,
        id,
      },
    },
    data: { model, id },
  };
}

/**
 * Load all main comment threads for the admin to see
 * @param {Params} params 
 */
export function loadThreads(params) {
  return {
    types: LOAD_THREADS,
    promise: {
      url: `/comments`,
      data: {
        page: 1,
        ...params,
      },
    },
  };
}

/**
 * Load a thread by the parent ID
 * @param {Number} id 
 */
export function loadThread(id) {
  return {
    types: LOAD_THREAD,
    promise: {
      url: `/comments/${id}`,
    },
  };
}

/**
 * Deletes a comment
 * @param {Comment} comment 
 */
export function deleteComment(comment) {
  return {
    types: DELETE_COMMENT,
    promise: {
      url: `/comments/${comment.id}`,
      method: 'DELETE',
    },
    data: {
      comment,
    },
  };
}
